module.exports = __webpack_public_path__ + "static/media/nasa.80115d2c.svg";